import React, { useEffect, useState } from "react";
import styled from "styled-components";
// Components
import BlogBox from "../Elements/BlogBox";
import FullButton from "../Buttons/FullButton";
import { useParams } from "react-router-dom";
import axios from "axios";
import TestimonialSlider from "../Elements/TestimonialSlider";
export default function Blog() {
  const backendUrl = process.env.REACT_APP_BACKEND_URL || "http://localhost:9000/";
  const { name } = useParams();
  const [data, setData] = useState();

  useEffect(() => {
    axios
      .get(`${backendUrl}/cms/name/${name}`)
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => {
        console.error("Error fetching section4 data:", err);
      });
  }, [backendUrl, name]);

  return (
    <Wrapper id="blog">
      <div className="whiteBg">
        <div className="container">
          <HeaderInfo>
            <h1 className="font40 extraBold">{data?.section4?.heading || "Our Graduate Stories"}</h1>
            <p className="font13">
              {data?.section4?.content ||
                "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua."}
            </p>
          </HeaderInfo>
          <div className="row textCenter">
            {data?.section4?.cards?.slice(0, 2).map((card) => (
              <div key={card._id} className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <BlogBox
                  title={card.title}
                  text={card.description}
                  author={`${card.name}, ${new Date(card.createdAt).toLocaleDateString("en-US", {
                    month: "short",
                    day: "numeric",
                    year: "numeric",
                  })}`}
                  tag="graduate"
                  action={() => alert("clicked")}
                />
              </div>
            ))}
            {data?.section4?.cards?.length < 2 && (
              <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                <BlogBox
                  title="Placeholder Story"
                  text="Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor."
                  tag="graduate"
                  author="Unknown, Today"
                  action={() => alert("clicked")}
                />
              </div>
            )}
          </div>
          <div className="row flexCenter">
            <div style={{ margin: "50px 0", width: "200px" }}>
              <FullButton title="Load More" action={() => alert("clicked")} />
            </div>
          </div>
        </div>
      </div>
      {data?.extra3?.isNeeded && (
        <div className="lightBg" style={{ padding: '50px 0' }}>
          <div className="container">
            <HeaderInfo>
              <h1 className="font40 extraBold">{data?.extra3?.title}</h1>
              <p className="font13" style={{ maxWidth: "600px" }}>
                {data?.extra3?.content ||
                  "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua."}
              </p>
            </HeaderInfo>
            <TestimonialSlider extra3={data?.extra3} />
          </div>
        </div>
      )}
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding-top: 20px;
`;
const HeaderInfo = styled.div`
  margin-bottom: 30px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;